import { defineStore } from 'pinia'

export const useOrderFormStore = defineStore('order-form', {
  state: () => ({
    clientDetails: {
      firstName: '',
      lastName: '',
      username: '',
      password: '',
      password2: ''
    },
    orderDetails: {
      product: null
    }
  }),
  actions: {
    updateClientDetails (payload) {
      this.clientDetails = {
        ...this.clientDetails,
        ...payload
      }
    },
    updateOrderDetails (payload) {
      this.orderDetails = {
        ...this.orderDetails,
        ...payload
      }
    },
    updateProduct (product) {
      this.orderDetails.product = product
    }
  },
  getters: {
    getClientDetails: ({ clientDetails }) => clientDetails,
    getClientEmail: ({ clientDetails }) => clientDetails.username,
    getOrderDetails: ({ orderDetails }) => orderDetails,
    getProduct: ({ orderDetails }) => orderDetails.product
  }
})
